import React, { useEffect, useState } from "react";
import { Avatar, Button, Table, Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import GetMerchants from "functions/admin/getMerchants";
import { useLoading } from "context/loadingContext";

const MerchantList = () => {
  const navigate = useNavigate();
  const { showLoading, hideLoading } = useLoading();
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchMerchants();
  }, []);

  const fetchMerchants = async () => {
    showLoading();
    try {
      const response = await GetMerchants();
      if (response) setData(response.data || []);
    } catch (error) {
      console.error("Error fetching merchants:", error);
    } finally {
      hideLoading();
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      width: 80,
    },
    {
      title: "Лого",
      dataIndex: "iconPath",
      key: "iconPath",
      width: 90,
      render: (iconPath, record) => (
        <Avatar
          shape="square"
          size={44}
          src={
            iconPath
              ? `https://storage.googleapis.com/smartbilling_hubilai/merchant/logo/${iconPath}`
              : "https://storage.googleapis.com/smartbilling_hubilai/logos/smartbillingbg.png"
          }
          alt={record.name}
        />
      ),
    },
    {
      title: "Мерчант",
      dataIndex: "name",
      key: "name",
      render: (value) => (
        <Tooltip title={value}>
          <span className="uppercase">{value}</span>
        </Tooltip>
      ),
    },
    {
      title: "Slogan",
      dataIndex: "slogan",
      key: "slogan",
      render: (value) => value || "-",
    },
    {
      title: "",
      key: "action",
      width: 100,
      align: "center",
      render: (_, record) => (
        <Button
          type="link"
          icon={<EyeOutlined />}
          onClick={() => navigate(`/adminMerchants/${record.id}`)}
        >
          Нээх
        </Button>
      ),
    },
  ];

  return (
    <div className="vatMerchantListontainer mt-3">
      <Table
        rowKey="id"
        columns={columns}
        dataSource={data}
        size="small"
        pagination={false}
        scroll={{ x: "max-content", y: "calc(100vh - 24vh)" }}
      />
    </div>
  );
};

export default MerchantList;
